import { FC } from "react";
import { useDispatch } from "react-redux";

import { ContentCopy } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, Text, Tooltip } from "@livechat/design-system-react-components";

import { CopyToClipboard } from "components/copy-to-clipboard-input";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { SettingsViewActions } from "store/views/settings";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";

import { trackAddressCopied } from "../analytics";

interface IForwardingAddressSummaryProps {
  inboxAddress: string;
  description: string;
}

export const ForwardingAddressSummary: FC<IForwardingAddressSummaryProps> = ({ inboxAddress, description }) => {
  const dispatch = useDispatch();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onCopied = () => {
    trackAddressCopied("main");
    dispatch(SettingsViewActions.forwardingAddressCopied());
  };

  return (
    <Block>
      <Flex alignItems="center">
        <Text css={textEllipsisStyles}>{inboxAddress}</Text>
        <CopyToClipboard value={inboxAddress} onCopiedHandler={onCopied}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {({ handleCopy }: any) => (
            <Tooltip
              kind="invert"
              triggerRenderer={
                <Button kind="plain" icon={<Icon source={ContentCopy} />} onClick={handleCopy} size="xcompact" />
              }
              activationThreshold={50}
              placement="top"
            >
              <Text>Copy address</Text>
            </Tooltip>
          )}
        </CopyToClipboard>
      </Flex>
      <Text customColor={withVar(DesignToken.ContentBasicSecondary)} css={textEllipsisStyles}>
        {description}
      </Text>
    </Block>
  );
};
